<template>
    <div :class="$style.categories">
        <BaseLink
            v-for="(category, index) in mainData.promoCategoriesList"
            :key="category.id"
            color="carbon-400"
            :style="{
                '--candy-color': colors[index % colors.length],
            }"
            :class="$style.link"
            data-interface-target="category"
            :to="category.location"
        >
            <Icon
                :name="category.id"
                :class="$style.icon"
            />
            <Typography
                type="label"
                size="s"
                :responsive="false"
            >
                {{ category.title }}
            </Typography>
        </BaseLink>
    </div>
</template>
<script lang="ts" setup>
import BaseLink from '@/components/BaseLink.vue'
import Icon from '@/components/Icon/Icon.vue'
import Typography from '@/components/Typography.vue'
import { useGeneralData } from '@/query/use-general-data'

const colors = [
    '#ff3b5c',
    '#c63ca2',
    '#558a2c',
    '#e04418',
    '#cc4d7c',
    '#49494f',
    '#582e6b',
    '#c92020',
    '#2d8a6e',
    '#0094c7',
    '#008a75',
    '#3d758f',
    '#5f9d2a',
    '#1c6cc6',
    '#2e8068',
    '#b1c400',
    '#6b4cc2',
    '#1d1c26',
]

const { mainData } = useGeneralData()
</script>
<style module>
.categories {
    display: flex;
    flex-wrap: wrap;
    justify-content: var(--promo-justify, start);
    gap: 8px;
}

.link {
    box-sizing: border-box;
    height: 48px;
    padding: 12px 20px;
    display: flex;
    gap: 8px;
    align-items: center;
    color: var(--text);
    transition: all 0.2s ease-in;
    border-radius: 1000px;
    border: 1px solid #1d1d21;
    background: var(--carbon-200);
    box-shadow: 0 0 20px 0 var(--deep-blue-500) inset;
}

.link:hover {
    background: var(--candy-color);
    box-shadow: none;
}

.icon {
    width: 24px;
    height: 24px;
    fill: var(--text);
}
</style>
